import React from "react";
import { Link, useLocation } from "react-router-dom";

const classNames = (...classes) => {
	return classes.filter(Boolean).join(" ");
};

const NavButton = ({ item, children, className, active, noFocus, onClick }) => {
	const { pathname } = useLocation();

	if (onClick) {
		return (
			<button onClick={onClick} className={classNames(className,
				(pathname === item.href || active) && !noFocus
					? "bg-primary text-bone"
					: "text-primary hover:bg-gray-300",
				"px-4 py-2 rounded-full text-md font-bold border-2 border-primary transition duration-250"
			)}>
				{children ? children: item.name}
			</button>
		);
	}

	return (
		<Link
			to={item.href}
			className={classNames(className,
				(pathname === item.href || active) && !noFocus
					? "bg-primary text-bone"
					: "text-primary hover:bg-gray-300",
				"px-4 py-2 rounded-full text-md font-bold border-2 border-primary transition duration-250"
			)}
		>
			{children ? children: item.name}
		</Link>
	);
};

export default NavButton;
